import { useEffect } from 'react';

import { navigate } from '@redwoodjs/router';

import { useAuthContext } from 'src/contexts/AuthProvider';
import { GuardProps } from 'src/types';

// ==============================|| LOGGED IN GUARD ||============================== //

/**
 * LoggedIn guard for routes
 * @param {PropTypes.node} children children element/node
 */
const LoggedInGuard = ({ children }: GuardProps) => {
    const { isUserLoggedIn } = useAuthContext();

    useEffect(() => {
        if (!isUserLoggedIn) {
            navigate('/login');
            return;
        }
    }, [isUserLoggedIn]);
    return children;
};

export default LoggedInGuard;
